<template>
  <div class="NewsList">

    <van-search v-model="searchVal"
                placeholder="搜索学校"
                show-action
                @search="onSearch">
      <template #action>
        <div @click="onSearch">
          <van-icon name="search" />
        </div>
      </template>
    </van-search>
    <div class="container _botline">
      <div class="selectCon">
        <van-row gutter="10">
          <van-col span="12">
            <div class="lis">
              <van-field v-model="dq_fieldValue"
                         is-link
                         readonly
                         label=""
                         placeholder="请选择地区"
                         @click="dq_show = true" />
              <van-popup v-model="dq_show"
                         round
                         position="bottom">
                <van-cascader v-model="dq_cascaderValue"
                              title="请选择所在地区"
                              :options="dq_options"
                              active-color="#263e65"
                              @close="dq_show = false"
                              @change="onChange_dq"
                              @finish="onFinish_dq" />
              </van-popup>
            </div>
          </van-col>
          <van-col span="12">
            <div class="lis">
              <van-field v-model="zy_fieldValue"
                         is-link
                         readonly
                         label=""
                         placeholder="请选择专业"
                         @click="zy_show = true" />
              <van-popup v-model="zy_show"
                         round
                         position="bottom">
                <van-cascader v-model="zy_cascaderValue"
                              title="请选择专业"
                              :options="zy_options"
                              active-color="#f29810"
                              @close="zy_show = false"
                              @finish="onFinish_zy" />
              </van-popup>
            </div>
          </van-col>
        </van-row>
      </div>

    </div>
    <div v-if="isSearch"
         class="search-detail">
      <div class="cont">
        <div class="loadingBox"
             v-if="loadingDetail">
          <van-loading size="24px"
                       vertical>加载中...</van-loading>
        </div>
        <transition name="van-fade">
          <div class="container"
               v-if="!loadingDetail">
            <van-row gutter="10">
              <van-col span="12"
                       v-for="(item,index) in searchList"
                       :key="index">
                <a :href="'/mobile/school-detail/'+item.id"
                   class="lis">
                  <div class="imgbox">
                    <span>
                      <i class="icobox"><img src="@/assets/ico1.png"
                             alt=""> </i> {{(item.rank == 9999 ? item.moerank:item.rank) == 9999 ? '-' :(item.rank == 9999 ? 'MOE:'+item.moerank:'QS:'+item.rank)}}
                    </span>
                    <img :src="item.thumb"
                         alt="">
                  </div>
                  <h3> {{item.name}} </h3>
                </a>
              </van-col>
            </van-row>
          </div>
        </transition>

      </div>
    </div>

    <van-tabs v-else
              v-model="active"
              border
              animated
              title-active-color="#263e65">
      <van-tab title="综合排名">
        <div class="cont">
          <div class="loadingBox"
               v-if="loadingDetail">
            <van-loading size="24px"
                         vertical>加载中...</van-loading>
          </div>
          <transition name="van-fade">

            <div class="container"
                 v-if="!loadingDetail">
              <van-row gutter="10">
                <van-col span="12"
                         v-for="(item,index) in recomendList"
                         :key="index">
                  <a :href="'/mobile/school-detail/'+item.id"
                     class="lis">
                    <div class="imgbox">
                      <span>
                        <i class="icobox"><img src="@/assets/ico1.png"
                               alt=""> </i> {{(item.rank == 9999 ? item.moerank:item.rank) == 9999 ? '-' :(item.rank == 9999 ? 'MOE:'+item.moerank:'QS:'+item.rank)}}
                      </span>
                      <img :src="item.thumb"
                           alt="">
                    </div>
                    <h3> {{item.name}} </h3>
                  </a>
                </van-col>
              </van-row>
              <van-pagination v-model="recomCuePage"
                              :total-items="recomTotal"
                              :show-page-size="7"
                              @change="changePageRec">
                <template #prev-text>
                  <van-icon name="arrow-left" />
                </template>
                <template #next-text>
                  <van-icon name="arrow" />
                </template>
                <template #page="{ text }">{{ text }}</template>
              </van-pagination>
            </div>
          </transition>

        </div>
      </van-tab>
      <van-tab title="热门专业">
        <div class="cont">
          <div class="loadingBox"
               v-if="loadingDetail">
            <van-loading size="24px"
                         vertical>加载中...</van-loading>
          </div>
          <transition name="van-fade">
            <div class="container"
                 v-if="!loadingDetail">
              <van-row gutter="10">
                <van-col span="12"
                         v-for="(item,index) in zyList"
                         :key="index">
                  <a :href="'/mobile/school-detail/'+item.id"
                     class="lis">
                    <div class="imgbox">
                      <span>
                        <i class="icobox"><img src="@/assets/ico1.png"
                               alt=""> </i> {{(item.rank == 9999 ? item.moerank:item.rank) == 9999 ? '-' :(item.rank == 9999 ? 'MOE:'+item.moerank:'QS:'+item.rank)}}
                      </span>
                      <img :src="item.thumb"
                           alt="">
                    </div>
                    <h3> {{item.name}} </h3>
                  </a>
                </van-col>
              </van-row>
              <van-pagination v-model="zyCuePage"
                              :total-items="zyTotal"
                              :show-page-size="7"
                              @change="changePagezy">
                <template #prev-text>
                  <van-icon name="arrow-left" />
                </template>
                <template #next-text>
                  <van-icon name="arrow" />
                </template>
                <template #page="{ text }">{{ text }}</template>
              </van-pagination>
            </div>
          </transition>

        </div>
      </van-tab>
      <van-tab title="热门院校">
        <div class="cont">
          <div class="loadingBox"
               v-if="loadingDetail">
            <van-loading size="24px"
                         vertical>加载中...</van-loading>
          </div>
          <transition name="van-fade">
            <div class="container"
                 v-if="!loadingDetail">
              <van-row gutter="10">
                <van-col span="12"
                         v-for="(item,index) in hotList"
                         :key="index">
                  <a :href="'/mobile/school-detail/'+item.id"
                     class="lis">
                    <div class="imgbox">
                      <span>
                        <i class="icobox"><img src="@/assets/ico1.png"
                               alt=""> </i> {{(item.rank == 9999 ? item.moerank:item.rank) == 9999 ? '-' :(item.rank == 9999 ? 'MOE:'+item.moerank:'QS:'+item.rank)}}
                      </span>
                      <img :src="item.thumb"
                           alt="">
                    </div>
                    <h3> {{item.name}} </h3>
                  </a>
                </van-col>
              </van-row>
              <van-pagination v-model="hotCuePage"
                              :total-items="hotTotal"
                              :show-page-size="7"
                              @change="changePageHot">
                <template #prev-text>
                  <van-icon name="arrow-left" />
                </template>
                <template #next-text>
                  <van-icon name="arrow" />
                </template>
                <template #page="{ text }">{{ text }}</template>
              </van-pagination>
            </div>
          </transition>

        </div>
      </van-tab>
    </van-tabs>

  </div>
</template>

<script>
import axiosApi from "../api/api.js";

export default {
  name: 'Home',
  components: {
  },
  data () {
    return {
      loadingDetail: true,
      active: 0,
      city: [],
      cyindex: 1,
      newslist: [],
      searchVal: '',
      dq_show: false,
      zy_show: false,
      dq_fieldValue: '',
      zy_fieldValue: '',
      dq_cascaderValue: '',
      zy_cascaderValue: '',
      dq_options: [],
      zy_options: [
        {
          text: 'Undergraduate',
          value: 'undergraduate',
          children: [],
        },
        {
          text: 'Masters degree',
          value: 'masters_degree',
          children: [],
        },
        {
          text: 'Doctoral',
          value: 'doctoral',
          children: [],
        },
      ],
      recomendList: [],
      recomCuePage: 1,
      recomTotal: 20,
      recomPageSize: 12,
      hotList: [],
      hotCuePage: 1,
      hotTotal: 20,
      hotPageSize: 12,
      zyList: [],
      zyCuePage: 1,
      zyTotal: 20,
      zyPageSize: 12,
      isSearch: false,
      searchList: [],
      sear_city: '',
      sear_xw: '',
      sear_major: '',

    }
  },
  mounted () {
    const ids = this.$route.params.index
    if (ids == 0) this.active = 0
    if (ids == 1) this.active = 1
    if (ids == 2) this.active = 2
    if (ids == 3) this.active = 3
    if (ids == 10) {
      this.isSearch = true
      axiosApi(
        'university/searchvocational?city_name=' + this.$route.query.city + '&status=1', {}, 'get'
      ).then((res) => {
        this.loadingDetail = false
        this.searchList = res.data
      })
    }
    if (ids == 11) {
      this.isSearch = true
      axiosApi(
        'university/searchvocational?name=' + this.$route.query.searchVal + '&status=1', {}, 'get'
      ).then((res) => {
        this.loadingDetail = false
        this.searchList = res.data
      })
    }

    axiosApi(
      'university/province', {}, 'get'
    ).then((res) => {
      const arr = res.data
      let narr = []
      arr.forEach(function (item) {
        narr = [...narr, { text: item.name, value: item.id, children: [] }]
      });
      this.dq_options = narr
    })
    axiosApi(
      'university/vocational', {}, 'get'
    ).then((res) => {
      const arr = res.data
      let uarr = []
      arr.forEach(function (item) {
        if (item.undergraduate) {
          item.undergraduate.forEach((item) => {
            uarr = [...uarr, item.program]
          })
        }
      });
      this.unique(uarr).forEach((item) => {
        this.zy_options[0].children = [...this.zy_options[0].children, { text: item, value: item }]
      })
      let marr = []
      arr.forEach(function (item) {
        if (item.masters_degree) {
          item.masters_degree.forEach((item) => {
            marr = [...marr, item.program]
          })
        }
      });
      this.unique(marr).forEach((item) => {
        this.zy_options[1].children = [...this.zy_options[1].children, { text: item, value: item }]
      })
      let darr = []
      arr.forEach(function (item) {
        if (item.doctoral) {
          item.doctoral.forEach((item) => {
            darr = [...darr, item.program]
          })
        }
      });
      this.unique(darr).forEach((item) => {
        this.zy_options[2].children = [...this.zy_options[2].children, { text: item, value: item }]
      })
    })
    axiosApi(
      'university/popular?rank', {}, 'get'
    ).then((res) => {
      setTimeout(() => {
        this.loadingDetail = false
      }, 500);
      this.recomendList = res.data.data
      this.recomCuePage = res.data.current_page
      this.recomTotal = res.data.total
      this.recomPageSize = res.data.per_page
    })
    axiosApi(
      'university/popular', {}, 'get'
    ).then((res) => {
      setTimeout(() => {
        this.loadingDetail = false
      }, 500);
      this.hotList = res.data.data
      this.hotCuePage = res.data.current_page
      this.hotTotal = res.data.total
      this.hotPageSize = res.data.per_page
    })
    axiosApi(
      'university/searchvocational', {}, 'get'
    ).then((res) => {
      setTimeout(() => {
        this.loadingDetail = false
      }, 500);
      this.zyList = res.data.data
      this.zyCuePage = res.data.current_page
      this.zyTotal = res.data.total
      this.zyPageSize = res.data.per_page
    })

  },
  methods: {
    unique (arr) {
      return Array.from(new Set(arr))
    },
    onChange_dq ({ value }) {
      let oldarr = this.dq_options
      let that = this
      oldarr.forEach(function (item, index) {
        if (item.value == value) {
          that.cyindex = index
        }
      });

      axiosApi(
        'university/province/' + value, {}, 'get'
      ).then((res) => {
        const arr = res.data
        let narr = []
        arr.forEach(function (item) {
          narr = [...narr, { text: item.name, value: item.code.slice(0, 4) }]
        });
        this.dq_options[this.cyindex].children = narr
      })

    },
    onFinish_dq ({ selectedOptions }) {
      this.dq_show = false;
      this.dq_fieldValue = selectedOptions.map((option) => option.text).join('/');
      this.loadingDetail = true
      this.isSearch = true
      this.sear_city = selectedOptions[1].value
      axiosApi(
        'university/searchvocational?city_name=' + this.sear_city + '&vocational=' + this.sear_xw + '&master=' + this.sear_major + '&status=1', {}, 'get'
      ).then((res) => {
        this.loadingDetail = false
        this.searchList = res.data
      })

      // city_name = 2302 & vocational=& master=undefined & status=1
    },
    onFinish_zy ({ selectedOptions }) {
      this.zy_show = false;
      this.zy_fieldValue = selectedOptions.map((option) => option.text).join('/');

      this.loadingDetail = true
      this.isSearch = true
      this.sear_xw = selectedOptions[0].value
      this.sear_major = selectedOptions[1].value
      axiosApi(
        'university/searchvocational?city_name=' + this.sear_city + '&vocational=' + this.sear_xw + '&master=' + this.sear_major + '&status=1', {}, 'get'
      ).then((res) => {
        this.loadingDetail = false
        this.searchList = res.data
      })
    },
    changePageRec (index) {
      console.log(index)
      this.loadingDetail = true
      axiosApi(
        'university/popular?rank&page=' + index, {}, 'get'
      ).then((res) => {
        setTimeout(() => {
          this.loadingDetail = false
        }, 500);
        this.recomendList = res.data.data
      })
    },
    changePageHot (index) {
      console.log(index)
      this.loadingDetail = true
      axiosApi(
        'university/popular?page=' + index, {}, 'get'
      ).then((res) => {
        setTimeout(() => {
          this.loadingDetail = false
        }, 500);
        this.hotList = res.data.data
      })
    },
    changePagezy (index) {
      console.log(index)
      this.loadingDetail = true
      axiosApi(
        'university/popular?page=' + index, {}, 'get'
      ).then((res) => {
        setTimeout(() => {
          this.loadingDetail = false
        }, 500);
        this.zyList = res.data.data
      })
    },

    onSearch () {
      this.loadingDetail = true
      this.isSearch = true
      axiosApi(
        'university/searchvocational?name=' + this.searchVal + '&status=1', {}, 'get'
      ).then((res) => {
        this.loadingDetail = false
        this.searchList = res.data
      })
    }
  },
}
</script>
<style lang="scss" scoped>
#app {
  background-color: #f7f8fa;
}
</style>
<style lang="scss" scoped>
._botline {
  border-bottom: 1px solid #ebedf080;
}
.container {
  padding: 25px;
}
.cont {
  min-height: 1200px;
  .loadingBox {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 500px;
  }
  .lis {
    display: block;
    margin-bottom: 20px;
    .imgbox {
      border-radius: 15px;
      position: relative;
      width: 340px;
      height: 200px;
      span {
        position: absolute;
        top: 0;
        left: 0;
        color: #fff;
        background-color: #f29810;
        padding: 10px;
        display: flex;
        align-items: center;
        line-height: 1;
        .icobox {
          width: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 10px;
          img {
            max-width: 100%;
          }
        }
      }
    }
    h3 {
      margin-top: 10px;
      text-align: center;
    }
  }
}
.van-search {
  background-color: #f7f8fa;
}
.van-search__content {
  background-color: #fff;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
}
.van-search--show-action {
  padding: 24px;
}
.van-search__action {
  background-color: #fff;
  border-left: 1px solid #f7f8fa;
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
}
</style>

<style lang="scss" >
.van-pagination__item {
  color: #263e65;
}
.van-pagination__item--active {
  color: #fff;
  background-color: #263e65;
}
.van-tabs__line {
  background-color: #263e65;
}
</style>